module.exports = __webpack_public_path__ + "static/media/foodTruck.d9a1344d.jpg";